// 이 기기에서 지금 게이트웨이를 쓰는 중인가 → 서버에 알린다(patch_mm_push_multidevice_n2_client.md §2-1).
//
// 서버(mm_notify)는 이 신호로 «지금 쓰는 기기»를 고른다 — 그 기기엔 메신저 푸시를 바로, 다른 기기엔
// 사용자가 고른 지연(내정보)만큼 기다렸다가 그 사이 안 읽었을 때만 보낸다(카톡·슬랙의 PC↔폰 규칙).
// 메신저 «보는 중» 신호(messengerOnScreen.js — 서버가 모든 기기를 건너뛴다)와는 별개다.
//  · 쓰는 중 = 탭이 보임 + 포커스 + 마지막 입력이 60초 안. 활동 중이면 20초마다 POST /api/push/active,
//    비활동 → 활동으로 바뀌는 순간(첫 입력·탭이 다시 보임·창 포커스)은 바로 1회(폰을 집어 든 순간부터).
//  · 입력 = pointerdown·keydown·touchstart·wheel — 최상위 창 + 같은 출처 iframe 창(메신저·드라이브는
//    같은 출처 iframe 이라 그 안 입력은 최상위로 안 올라온다 → iframe 이 load 될 때마다 그 창에도 단다).
//    🔴 scroll 은 세지 않는다 — 스크립트가 바꾼 스크롤에도 뜬다(새 DM 이 오면 메신저가 글 목록을 아래로 내린다 →
//    자리를 비운 PC 가 «쓰는 중»이 돼 폰 알림이 막힌다). 사람이 하는 스크롤은 wheel·touchstart·keydown·pointerdown 이 덮는다.
//  · 포커스가 리스너를 못 단 문서(다른 출처·안쪽 iframe — 예: 드라이브 속 문서 편집기) 안이면 입력이 안 보이므로
//    60초 대신 5분까지 쓰는 중으로 본다(문서를 쓰거나 읽는 동안 폰이 울리지 않게 · 5분 뒤엔 자리 비움).
//  · 앱이 열릴 때(시작·탭이 다시 보임·focus) 서비스워커에 'aigw-mm-sweep' — 다른 기기에서 읽은 알림을 닫는다.
//    iOS 설치형 앱은 새로 켤 때 visibilitychange 가 안 올 수 있어 focus 도 쓴다. 🔴 focus 로 부르는 정리는 직전 정리
//    뒤 60초가 지났을 때만 — 창을 오가며 focus 가 잦으면 남은 알림마다 /api/push/mm-read(IP 당 한도 · 사무실 NAT
//    공유)를 부른다. 시작·다시 보임은 바로(2초 안 중복만 합친다).
// 🔴 pushAPI.active 가 함수일 때만 부르고 실패·예외는 삼킨다(api/client 를 mock 한 기존 시험이 깨지지 않게 —
//    messengerOnScreen.js sendViewing 관례). 그 요청은 401 이어도 로그아웃하지 않는다(client.js QUIET_401).
//    로그인 토큰이 없으면 아예 보내지 않는다.
//  · 구독 endpoint 는 값이 있을 때만 5분 캐시한다 — null(구독 없음)까지 캐시하면 알림을 켠 직후 최대 5분 동안
//    신호가 endpoint 없이 나가 «쓰는 기기» 가 없는 것으로 보였다(patch_mm_push_multidevice_n2b — #1277).
//    구독이 바뀌면(messengerOnScreen.onPushSubscriptionChanged) 캐시를 비우고, 쓰는 중이면 바로 1회 보낸다.
//    🔴 그 export 는 있을 때만 건다(그 모듈을 부분 대역으로 바꾼 시험 — utils/push.js 와 같은 가드).
//  · 앱이 열릴 때(시작·10분 넘게 지난 다시 보임) 서비스워커의 push 고리 기록(Cache Storage · service-worker.js swRingPush)을
//    로그인 요청(POST /api/push/sw-ring)으로 올린다(patch_sw_push_event_settles_after_show.md §3-3). 고리 캐시가 없는 기기
//    (진단 push 를 받은 적 없음)는 아무것도 안 한다. 2xx 뒤에 보낸 키만 지우고, 다른 판(v) 키는 보내지도 지우지도 않는다.
import { pushAPI } from './api/client';
import { onPushSubscriptionChanged } from './messengerOnScreen';

export const ACTIVE_HEARTBEAT_MS = 20000;
export const INPUT_IDLE_MS = 60 * 1000;
export const BLIND_INPUT_IDLE_MS = 5 * 60 * 1000;   // 포커스가 입력을 못 보는 문서 안일 때
export const ENDPOINT_CACHE_MS = 5 * 60 * 1000;
export const SWEEP_MIN_GAP_MS = 2000;                // 보임·focus 가 한꺼번에 와도 정리 요청은 1번
export const SWEEP_FOCUS_GAP_MS = 60 * 1000;         // focus 로 부르는 정리는 직전 정리 뒤 이만큼 지나야
export const MM_SWEEP_MESSAGE = 'aigw-mm-sweep';
// 고리 기록 — service-worker.js 와 쌍둥이(바꾸면 둘 다).
export const SW_DIAG_VER = 'r8';
export const SW_RING_CACHE = 'aigw-pushdiag';
export const SW_RING_PREFIX = '/__aigw-pushdiag/';
export const SW_RING_META = '/__aigw-pushdiag-meta';
export const SW_RING_UPLOAD_GAP_MS = 10 * 60 * 1000;
export const SW_RING_BATCH = 70;                     // 한 요청 줄 상한 — 서버 /api/push/sw-ring 과 같은 값
const SW_RING_MAX_BATCHES = 3;                       // 고리 200줄 = 70·70·60
const SW_RING_MAX_REGS = 3;                          // 서버 상한 — 넘기면 그 기기는 영구 422
const SW_RING_PATH_MAX = 120;
const SW_RING_B = ['p', 'g', 'k', 's', 'u'];
const SW_RING_R = ['n', 'r', 'f', 'z', 'x', 'e', 'a'];
const SW_REG_PATH_RE = /^\/[\x21\x23-\x5b\x5d-\x7e]{0,119}$/;   // 서버 정규식과 같다(같은 출처 ASCII 경로 · " \ 제외)

const INPUT_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
const LISTEN_OPTS = { capture: true, passive: true };
const FRAME_MARK = '__aigwDeviceActivity';            // 리스너를 단 iframe 창에 단다(값 = 그 인스턴스)
const MAX_FRAME_DEPTH = 8;

function hasToken() {
  try {
    return !!localStorage.getItem('token');
  } catch (e) {
    return false;
  }
}

function canSend() {
  return !!(pushAPI && typeof pushAPI.active === 'function');
}

function swContainer() {
  try {
    return (typeof navigator !== 'undefined' && navigator.serviceWorker) || null;
  } catch (e) {
    return null;
  }
}

function isIframe(el) {
  try {
    return !!el && String(el.tagName || '').toUpperCase() === 'IFRAME';
  } catch (e) {
    return false;
  }
}

// 서비스워커에 읽은 메신저 알림 정리를 부탁한다. 제어 중인 SW 가 없으면(첫 방문 등) 등록의 active 에.
export function requestMmSweep() {
  try {
    const sw = swContainer();
    if (!sw) return;
    const msg = { type: MM_SWEEP_MESSAGE };
    if (sw.controller && typeof sw.controller.postMessage === 'function') {
      sw.controller.postMessage(msg);
      return;
    }
    if (typeof sw.getRegistration !== 'function') return;
    Promise.resolve(sw.getRegistration())
      .then((reg) => {
        const target = reg && reg.active;
        if (target && typeof target.postMessage === 'function') target.postMessage(msg);
      })
      .catch(() => { /* 정리는 다음에 앱을 열 때 다시 */ });
  } catch (e) { /* */ }
}

const isInt = (x) => typeof x === 'number' && Number.isInteger(x);

// 고리 한 줄 [t, b, n, v, r, p, s, i, q] 이 서버 스키마에 맞는가(형식 밖 한 줄이 요청 전체를 422 로 만들지 않게 미리 거른다).
function swRingRowOk(row) {
  if (!Array.isArray(row) || row.length !== 9) return false;
  const [t, b, n, v, r, p, s, i, q] = row;
  return isInt(t) && t > 0 && t < 1e13
    && SW_RING_B.includes(b)
    && isInt(n) && n >= -2 && n <= 1000
    && (v === 0 || v === 1)
    && SW_RING_R.includes(r)
    && typeof p === 'string' && /^[0-9a-f]{1,16}$/.test(p)
    && typeof s === 'string' && /^[0-9a-f]{0,16}$/.test(s)
    && typeof i === 'string' && /^[0-9a-z]{4}$/.test(i)
    && isInt(q) && q >= 1 && q <= 999999;
}

function swRingKeyPath(k) {
  try {
    const url = typeof k === 'string' ? k : (k && k.url);
    return url ? new URL(url, window.location.href).pathname : '';
  } catch (e) {
    return '';
  }
}

// 같은 출처 URL → 경로(120자에서 자름 · 서버 정규식 밖이면 null). URL 파서가 " 를 %22 로, \ 를 / 로 바꾼다.
function swRegPath(url) {
  if (typeof url !== 'string' || !url) return null;
  try {
    const u = new URL(url, window.location.href);
    if (u.origin !== window.location.origin) return null;
    const p = u.pathname.slice(0, SW_RING_PATH_MAX);
    return SW_REG_PATH_RE.test(p) ? p : null;
  } catch (e) {
    return null;
  }
}

// 이 출처의 서비스워커 등록 목록 { scope, script, sub } — 자체 가드·자체 try(없거나 던지면 [] · 업로드는 그대로 간다).
// sub = 그 등록에 push 구독이 있음 1 · 없음 0 · 못 읽음 -1(endpoint 원문은 싣지 않는다).
async function swRingRegs() {
  try {
    const sw = swContainer();
    if (!sw || typeof sw.getRegistrations !== 'function') return [];
    const list = (await sw.getRegistrations()) || [];
    const out = [];
    for (const reg of Array.from(list)) {
      if (out.length >= SW_RING_MAX_REGS) break;
      if (!reg) continue;
      const scope = swRegPath(reg.scope);
      const worker = reg.active || reg.waiting || reg.installing;
      const scriptUrl = (worker && worker.scriptURL) || '';
      const script = scriptUrl ? swRegPath(scriptUrl) : '';
      if (!scope || script === null) continue;
      let sub = -1;
      try {
        const pm = reg.pushManager;
        if (pm && typeof pm.getSubscription === 'function') sub = (await pm.getSubscription()) ? 1 : 0;
      } catch (e) { sub = -1; }
      out.push({ scope, script, sub });
    }
    return out;
  } catch (e) {
    return [];
  }
}

// META { v, born, dropped } — 읽기만 한다(SW 만 쓴다). 판이 다르거나 형식 밖이면 0·''.
async function swRingMeta(cache) {
  try {
    const hit = await cache.match(SW_RING_META);
    const m = hit ? await hit.json() : null;
    if (m && m.v === SW_DIAG_VER && typeof m.born === 'string' && /^[0-9a-f]{8}$/.test(m.born)
        && isInt(m.dropped) && m.dropped >= 0 && m.dropped <= 1e9) {
      return { born: m.born, dropped: m.dropped };
    }
  } catch (e) { /* 못 읽으면 기본값 */ }
  return { born: '', dropped: 0 };
}

// 고리 기록을 올린다. 요청을 1번이라도 보냈으면 true.
// 🔴 확인 순서: caches → pushAPI.swRing → 토큰 → caches.has(없으면 open 으로 빈 캐시를 만들지 않는다).
//    키 목록은 한 번만 읽어 이름순(= 기기 시각·인스턴스·순번순)으로 고정한다 — 보내는 사이 SW 가 더한 키는 다음 호출 몫.
export async function uploadSwRing(getEndpoint) {
  let sent = false;
  try {
    if (typeof window === 'undefined' || !window.caches) return false;
    if (!(pushAPI && typeof pushAPI.swRing === 'function')) return false;
    if (!hasToken()) return false;
    const store = window.caches;
    if (!(await store.has(SW_RING_CACHE))) return false;
    const cache = await store.open(SW_RING_CACHE);
    const paths = ((await cache.keys()) || []).map(swRingKeyPath)
      .filter((p) => p.indexOf(SW_RING_PREFIX) === 0).sort();
    const queue = [];
    let otherVer = 0;
    for (const p of paths) {
      let val = null;
      try {
        const hit = await cache.match(p);
        val = hit ? await hit.json() : null;
      } catch (e) { val = null; }
      if (val && typeof val.v === 'string' && val.v !== SW_DIAG_VER) {
        otherVer += 1;                             // 다른 판 SW 가 쓴 줄 — 보내지도 지우지도 않는다(SW 의 200개 상한이 밀어낸다)
        continue;
      }
      if (val && val.v === SW_DIAG_VER && swRingRowOk(val.row)) {
        queue.push({ path: p, row: val.row });
        continue;
      }
      try { await cache.delete(p); } catch (e) { /* 같은 판 형식 밖·판을 알 수 없는 값 — 거를 때 바로 지운다 */ }
    }
    // 보낼 줄이 없어도 다른 판 키가 없으면 빈 업로드 1번(«발송 뒤 이 기기가 열렸는데 그 줄이 없다»를 서버가 보게).
    if (!queue.length && otherVer > 0) return false;
    const meta = await swRingMeta(cache);
    const regs = await swRingRegs();
    let endpoint = null;
    try { endpoint = (typeof getEndpoint === 'function' ? await getEndpoint() : null) || null; } catch (e) { endpoint = null; }
    const body = (rows) => ({ endpoint, ver: SW_DIAG_VER, born: meta.born, rows, regs, dropped: meta.dropped });
    const ok = (res) => !(res && typeof res.status === 'number' && (res.status < 200 || res.status >= 300));
    if (!queue.length) {
      sent = true;
      await pushAPI.swRing(body([]));
      return sent;
    }
    for (let n = 0; n < SW_RING_MAX_BATCHES && queue.length; n += 1) {
      const batch = queue.splice(0, SW_RING_BATCH);
      sent = true;
      const res = await pushAPI.swRing(body(batch.map((x) => x.row)));   // 2xx 가 아니면(거부) 바깥 catch — 키 그대로·여기서 멈춘다
      if (!ok(res)) return sent;
      for (const x of batch) {
        try { await cache.delete(x.path); } catch (e) { /* 다음 업로드에서 다시 간다(판정 때 중복 제거) */ }
      }
    }
    return sent;
  } catch (e) {
    return sent;   // 보낸 뒤 거부(503·413·429)여도 «올리기 시도»로 센다 — 다음 시도는 10분 뒤
  }
}

// SplitShell 이 마운트 때 건다. 반환값 = 해제 함수.
export function startDeviceActivity() {
  const instance = {};             // 이 인스턴스 표식(iframe 창의 FRAME_MARK 값)
  const frames = new Set();        // 리스너를 단 iframe 창(해제용)
  let stopped = false;
  let active = false;
  let timer = null;
  let blurTimer = null;
  let lastInputAt = null;
  let lastSweepAt = null;
  let endpoint = null;
  let endpointAt = null;
  let endpointInFlight = null;
  // 구독이 바뀔 때마다 1씩 올린다 — 바뀌기 «전에» 시작한 조회가 바뀐 «뒤에» 끝나면 캐시를 건드리지 않는다.
  let endpointGen = 0;
  let unsubSubChanged = null;
  let lastRingAt = null;           // 이 탭에서 고리 기록을 마지막으로 올린 시각(올린 적 없으면 null = 지난 것으로 본다)
  let ringInFlight = false;

  const now = () => Date.now();

  // 이 브라우저의 푸시 구독 endpoint(없으면 null · 값이 있을 때만 5분 캐시 · null·실패는 캐시하지 않는다).
  const getEndpoint = () => {
    if (endpointAt !== null && now() - endpointAt < ENDPOINT_CACHE_MS) return Promise.resolve(endpoint);
    if (endpointInFlight) return endpointInFlight;
    const gen = endpointGen;
    const done = (v) => {
      const ep = typeof v === 'string' && v ? v : null;
      if (gen !== endpointGen) return ep;   // 구독이 바뀐 뒤 끝난 옛 조회 — 캐시·뒤 조회의 진행 표시를 건드리지 않는다
      endpoint = ep;
      endpointAt = null;                    // 🔴 null(구독 없음·SW 없음·조회 실패)은 캐시하지 않는다 — 다음 신호에서 다시 읽는다
      if (typeof ep === 'string') endpointAt = now();
      endpointInFlight = null;
      return ep;
    };
    try {
      const sw = swContainer();
      if (!sw || typeof sw.getRegistration !== 'function') return Promise.resolve(done(null));
      endpointInFlight = Promise.resolve(sw.getRegistration())
        .then((reg) => {
          const pm = reg && reg.pushManager;
          return pm && typeof pm.getSubscription === 'function' ? pm.getSubscription() : null;
        })
        .then((sub) => done(sub && sub.endpoint), () => done(null));
      return endpointInFlight;
    } catch (e) {
      return Promise.resolve(done(null));
    }
  };

  // 구독이 바뀌었다 — 캐시를 비우고 진행 중인 조회는 옛 세대로 돌린다.
  const invalidateEndpoint = () => {
    endpointGen += 1;
    endpoint = null;
    endpointAt = null;
    endpointInFlight = null;
  };

  const send = () => {
    if (!canSend() || !hasToken()) return;
    const gen = endpointGen;
    getEndpoint()
      .then((ep) => {
        // 조회하는 사이 구독이 바뀌었으면 옛 endpoint 를 보내지 않는다(쓰는 중이면 바뀐 쪽이 새 세대로 다시 보냈다).
        if (stopped || gen !== endpointGen || !canSend() || !hasToken()) return;
        const p = pushAPI.active(ep);
        if (p && typeof p.catch === 'function') p.catch(() => { /* 다음 주기에 다시 보낸다 */ });
      })
      .catch(() => { /* 실패는 삼킨다 */ });
  };

  // minGap = 직전 정리 뒤 이만큼 안 지났으면 건너뛴다(시작·다시 보임 = 2초 · focus = 60초).
  const sweep = (minGap) => {
    const t = now();
    if (lastSweepAt !== null && t >= lastSweepAt && t - lastSweepAt < minGap) return;
    lastSweepAt = t;
    requestMmSweep();
  };

  // 고리 기록 올리기 — 시작 때 1회 · 다시 보임은 직전 올리기 뒤 10분이 지났을 때만(시계가 뒤로 갔으면 지난 것으로 본다).
  const ringUpload = () => {
    if (stopped || ringInFlight) return;
    const t = now();
    if (lastRingAt !== null && t >= lastRingAt && t - lastRingAt < SW_RING_UPLOAD_GAP_MS) return;
    ringInFlight = true;
    uploadSwRing(getEndpoint)
      .then((sent) => { if (sent) lastRingAt = now(); })
      .catch(() => { /* uploadSwRing 은 던지지 않는다 */ })
      .then(() => { ringInFlight = false; });
  };

  // 포커스를 따라 iframe 안쪽으로 내려가며 끝까지 리스너를 단 문서인지 본다. 못 단 문서(다른 출처·안쪽 iframe)면 false.
  const focusInWatchedDoc = () => {
    let doc = document;
    for (let i = 0; i < MAX_FRAME_DEPTH; i += 1) {
      let el = null;
      try { el = doc.activeElement; } catch (e) { return false; }
      if (!isIframe(el)) return true;
      try {
        const win = el.contentWindow;
        if (!win || win[FRAME_MARK] !== instance) return false;
        doc = win.document;
      } catch (e) {
        return false;
      }
      if (!doc) return false;
    }
    return false;
  };

  const isActiveNow = () => {
    try {
      if (typeof document === 'undefined') return false;
      if (document.visibilityState !== 'visible' || !document.hasFocus()) return false;
      if (lastInputAt === null) return false;
      const t = now();
      if (t < lastInputAt) lastInputAt = t;   // 시계가 뒤로 갔다 — 지금 입력한 것으로 본다
      const limit = focusInWatchedDoc() ? INPUT_IDLE_MS : BLIND_INPUT_IDLE_MS;
      return t - lastInputAt < limit;
    } catch (e) {
      return false;
    }
  };

  const stopTimer = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const evaluate = () => {
    if (stopped) return;
    const on = isActiveNow();
    if (on && !active) {
      active = true;
      send();                       // 비활동 → 활동: 바로 1회
      stopTimer();
      timer = setInterval(() => {
        if (isActiveNow()) send();
        else evaluate();            // 이벤트 없이 바뀐 경우(입력 없이 60초 등) — 하트비트를 멈춘다
      }, ACTIVE_HEARTBEAT_MS);
    } else if (!on && active) {
      active = false;
      stopTimer();
    }
  };

  const markInput = () => {
    if (stopped) return;
    lastInputAt = now();
    if (!active) evaluate();
  };

  const onInput = () => markInput();

  const attachFrame = (frame) => {
    let win = null;
    try { win = frame && frame.contentWindow; } catch (e) { win = null; }
    if (!win) return;
    try {
      if (win[FRAME_MARK] === instance) return;
      INPUT_EVENTS.forEach((type) => win.addEventListener(type, onInput, LISTEN_OPTS));
      win[FRAME_MARK] = instance;
      frames.add(win);
    } catch (e) { /* 다른 출처 — 건너뛴다(포커스가 그 안이면 5분 기준) */ }
  };

  // iframe 의 load 는 버블되지 않고 창(window)까지 가지도 않는다 → document 캡처로 받는다.
  const onFrameLoad = (e) => {
    if (isIframe(e && e.target)) attachFrame(e.target);
  };

  const onVisibility = () => {
    let visible = false;
    try { visible = document.visibilityState === 'visible'; } catch (e) { visible = false; }
    if (visible) {
      sweep(SWEEP_MIN_GAP_MS);
      markInput();                  // 탭·앱을 다시 앞으로 가져온 것 = 사용자 조작
      ringUpload();
    } else {
      evaluate();
    }
  };

  const onFocus = () => {
    sweep(SWEEP_FOCUS_GAP_MS);      // 창을 오가며 잦게 오는 focus 가 읽음 조회를 쏟지 않게
    markInput();
  };

  // 🔴 blur 는 포커스가 iframe 안으로 들어갈 때도 뜬다(최상위 hasFocus 는 그대로 true) → 다음 틱에 다시 판정한다.
  const onBlur = () => {
    if (blurTimer) clearTimeout(blurTimer);
    blurTimer = setTimeout(() => {
      blurTimer = null;
      evaluate();
    }, 0);
  };

  // 구독이 바뀌면(알림 켜기·끄기·로그아웃·회전·다른 탭) 캐시를 비우고, 쓰는 중이면 하트비트를 기다리지 않고 바로 1회.
  // 쓰는 중이 아니면 비우기만 한다 — 다음 «비활동 → 활동» 첫 신호가 새로 읽는다.
  try {
    if (typeof onPushSubscriptionChanged === 'function') {
      unsubSubChanged = onPushSubscriptionChanged(() => {
        if (stopped) return;
        invalidateEndpoint();
        if (active) send();
      });
    }
  } catch (e) { unsubSubChanged = null; /* 못 걸면 다음 하트비트(20초 안)에 따라잡는다 */ }

  try {
    INPUT_EVENTS.forEach((type) => window.addEventListener(type, onInput, LISTEN_OPTS));
    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    document.addEventListener('visibilitychange', onVisibility);
    document.addEventListener('load', onFrameLoad, true);
    Array.prototype.forEach.call(document.querySelectorAll('iframe'), attachFrame);
  } catch (e) { /* 리스너를 못 걸면 신호를 안 보낼 뿐이다(서버는 종전처럼 동작) */ }
  sweep(SWEEP_MIN_GAP_MS);
  evaluate();
  ringUpload();

  return () => {
    stopped = true;
    active = false;
    stopTimer();
    if (blurTimer) {
      clearTimeout(blurTimer);
      blurTimer = null;
    }
    if (typeof unsubSubChanged === 'function') {
      try { unsubSubChanged(); } catch (e) { /* 해제 실패가 나머지 해제를 막지 않게 */ }
    }
    unsubSubChanged = null;
    try {
      INPUT_EVENTS.forEach((type) => window.removeEventListener(type, onInput, LISTEN_OPTS));
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
      document.removeEventListener('visibilitychange', onVisibility);
      document.removeEventListener('load', onFrameLoad, true);
    } catch (e) { /* */ }
    frames.forEach((win) => {
      try {
        INPUT_EVENTS.forEach((type) => win.removeEventListener(type, onInput, LISTEN_OPTS));
        if (win[FRAME_MARK] === instance) delete win[FRAME_MARK];
      } catch (e) { /* 이미 닫힌 창 */ }
    });
    frames.clear();
  };
}
